import { ApiProvider } from 'providers/request'
import { LayerGroup, AddFeatureParams, UpdateFeatureParams } from 'models/layer'
import { InfowindowData } from 'models/infowindow'
import { objectToFormData } from 'utils/object-to-formdata'

export const LayerRepository = {
  fetchAll(): Promise<LayerGroup[]> {
    return ApiProvider.get('/layers')
  },

  addFeature(layerId: number, data: AddFeatureParams): Promise<InfowindowData> {
    var obj = data
    var datacolumns = JSON.stringify(obj.data)
    datacolumns = datacolumns.replace('{', '')
    datacolumns = datacolumns.replace('}', '')
    var coords = JSON.stringify(obj.feature.geometry.coordinates)
    var strdata =
      '{"areaType":' +
      JSON.stringify(obj.feature.geometry.type) +
      ',' +
      datacolumns +
      ', "coordinates":' +
      coords +
      '}'
    var dat = objectToFormData({ File, data: strdata })
    return ApiProvider.post(`/custom_layer/${layerId}/feature`, dat)
  },

  updateFeature(
    layerId: number,
    featureId: number,
    data: UpdateFeatureParams,
  ): Promise<InfowindowData> {
    var obj = data

    var datacolumns = JSON.stringify(obj.data)
    datacolumns = datacolumns.replace('{', '')
    datacolumns = datacolumns.replace('}', '')

    var strdata = '{' + datacolumns + ', "type":"edit"}'

    const formData = objectToFormData({ data: JSON.parse(JSON.stringify(strdata)) })

    return ApiProvider.patch(`/custom_layer/${layerId}/feature/${featureId}`, formData)
  },

  deleteFeature(layerId: number, featureId: number): Promise<void> {
    var strdata = '{"type":"delete"}'

    const formData = objectToFormData({ data: JSON.parse(JSON.stringify(strdata)) })

    return ApiProvider.patch(`/custom_layer/${layerId}/feature/${featureId}`, formData)
  },
}
